import { createClient, SupabaseClient } from "@supabase/supabase-js";
import { isNative } from "../lib/platform";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

export const supabaseConfigured = Boolean(supabaseUrl && supabaseAnonKey);

// Cast to SupabaseClient so callers don't need null checks — but only
// call methods when supabaseConfigured is true.
export const supabase = supabaseConfigured
  ? createClient(supabaseUrl!, supabaseAnonKey!, {
      auth: {
        // PKCE is required for deep-link auth on iOS (code verifier lives in
        // the app, not the URL, so tokens can't be intercepted by other apps).
        // On web, use implicit flow so the session is delivered via hash
        // fragment (#access_token=...) and works even when the confirmation
        // link is opened in a fresh browser session (no code verifier needed).
        flowType: isNative ? "pkce" : "implicit",
        // On native, redirect email verification links to our custom URL
        // scheme so iOS opens the app instead of a browser.
        ...(isNative && { redirectTo: "com.weightplanner.app://" }),
      },
    })
  : (null as unknown as SupabaseClient);
